/**
 * Enriches raw buildings with CMS phasing data and tier-derived state.
 *
 * Buildings and phasing entries are joined by `id_cad`. `hasActiveTiers`
 * reports whether at least one derived tier is active; buildings without
 * product-relevant tiers remain active by default. `isSoldOut` is true only
 * when the building has derived tiers and every one of them is sold out.
 * Input arrays and their entries are not mutated.
 *
 * @param {Object[]} buildings - Structurally normalized buildings loaded from `buildings.json`.
 * @param {Object[]} [tiers=[]] - Product-relevant, derived Inventory tiers.
 * @param {Object[]} [phasingConfig=[]] - CMS `phasing_config.buildings` entries.
 * @returns {Object[]} Buildings enriched with matching phasing fields, `hasActiveTiers`, and `isSoldOut`.
 */
export function buildBuildingsData(buildings, tiers = [], phasingConfig = []) {
  if (!buildings?.length) return []

  const enhancedBuildings = buildings.map((building) => {
    const buildingId = building.id_cad
    const buildingPhasing = phasingConfig.find((bp) => bp.id_cad === buildingId)
    const buildingTiers = tiers.filter((t) => t.building_id === buildingId)

    const hasActiveTiers = buildingTiers.length > 0
      ? buildingTiers.some((t) => t.isActive)
      : true

    const isSoldOut = buildingTiers.length > 0
      && buildingTiers.every((t) => t.isSoldOut)

    return {
      ...building,
      ...buildingPhasing,
      hasActiveTiers,
      isSoldOut,
    }
  })

  return enhancedBuildings
}
